import infoImage from "../assets/images/info.svg";

const d = document;
// Inject Info icon for email hover information
// TODO: create email module
const emailInfoImage = d.querySelector(".email-info");
emailInfoImage.src = infoImage;

// Copy email adress to clipboard
const mailToLink = d.querySelector(".email-address");
mailToLink.addEventListener("click", () => {
  navigator.clipboard
    .writeText("cleanundfrisch@gmail.com")
    .then((success, error) => {
      if (error) {
        reject(
          alert("Konnte nicht kopiert werden, manuelle Eingabe erforderlich.")
        );
      }
    });
});
